var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.active)?_c('Identification',{attrs:{"value":_vm.profile},on:{"input":function($event){return _vm.$emit('input')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }